import React, { useEffect, useState } from 'react';
import { collection, getDocs } from 'firebase/firestore';
import { db } from '../firebase';
import WorkerCard from '../components/WorkerCard';
import '../components/Services.css';

const SERVICE_LABELS = {
    'electrician': 'Electrician',
    'plumber': 'Plumber',
    'carpenter': 'Carpenter',
    'painter': 'Painter',
    'ac-repair': 'AC Repair',
    'cleaning': 'Cleaning',
    'glass-windows': 'Glass & Windows',
    'home-renovation': 'Home Renovation',
};

const WorkersPage = () => {
    const [workers, setWorkers] = useState([]);
    const [loading, setLoading] = useState(true);
    const [filter, setFilter] = useState('all');
    const [sort, setSort] = useState('rating');

    useEffect(() => {
        const fetchProviders = async () => {
            try {
                const snap = await getDocs(collection(db, 'serviceProviders'));
                const data = snap.docs.map(d => ({ id: d.id, ...d.data() }));
                setWorkers(data);
            } catch (e) {
                console.error('Failed to load providers:', e);
            } finally {
                setLoading(false);
            }
        };
        fetchProviders();
    }, []);

    const filtered = workers
        .filter(w => filter === 'all' || (w.serviceCategory || '').toLowerCase().replace(/\s+/g, '-') === filter)
        .sort((a, b) => {
            if (sort === 'rating') return (b.rating || 0) - (a.rating || 0);
            if (sort === 'price-asc') return (a.hourlyRate || 0) - (b.hourlyRate || 0);
            if (sort === 'price-desc') return (b.hourlyRate || 0) - (a.hourlyRate || 0);
            if (sort === 'jobs') return (b.completedJobs || 0) - (a.completedJobs || 0);
            return 0;
        });

    return (
        <section className="services-section section">
            <div className="container">
                <div className="section-header">
                    <h2>Our Verified Professionals</h2>
                    <p>Find the best professionals for your needs</p>
                </div>

                <div className="filter-section">
                    <select className="filter-select" value={filter} onChange={e => setFilter(e.target.value)}>
                        <option value="all">All Services</option>
                        {Object.entries(SERVICE_LABELS).map(([val, label]) => (
                            <option key={val} value={val}>{label}</option>
                        ))}
                    </select>
                    <select className="filter-select" value={sort} onChange={e => setSort(e.target.value)}>
                        <option value="rating">Sort by Rating</option>
                        <option value="price-asc">Price: Low to High</option>
                        <option value="price-desc">Price: High to Low</option>
                        <option value="jobs">Most Jobs Completed</option>
                    </select>
                </div>

                {loading ? (
                    <div style={{ textAlign: 'center', padding: '3rem', color: '#888' }}>Loading professionals…</div>
                ) : filtered.length === 0 ? (
                    <div style={{ textAlign: 'center', padding: '3rem', color: '#888' }}>
                        No professionals found{filter !== 'all' ? ` for "${SERVICE_LABELS[filter] || filter}"` : ''}. Check back soon!
                    </div>
                ) : (
                    <div className="services-grid">
                        {filtered.map((worker) => (
                            <WorkerCard
                                key={worker.id}
                                name={worker.name}
                                profession={SERVICE_LABELS[worker.serviceCategory] || worker.serviceCategory}
                                rating={worker.rating ? worker.rating.toFixed(1) : '—'}
                                completedJobs={worker.completedJobs || 0}
                                hourlyRate={worker.hourlyRate || 0}
                                skills={worker.skills || []}
                                verified={worker.isVerified || false}
                            />
                        ))}
                    </div>
                )}
            </div>
        </section>
    );
};

export default WorkersPage;
